/* eslint-disable no-console */

/*
drawer
*/
document.addEventListener("DOMContentLoaded", function () {
    const open = document.getElementById('button-drawer-open');
    const close = document.getElementById('button-drawer-close');
    const drawer = document.getElementById("section-drawer");
    const drawer_background = document.getElementById("drawer-background");

    open.addEventListener('click', function () {
        drawer_background.classList.toggle('__active');
        drawer.classList.toggle('__active');
    }, false);
    close.addEventListener('click', function () {
        drawer_background.classList.toggle('__active');
        drawer.classList.toggle('__active');
    }, false);

    drawer_background.addEventListener('click', function () {
        drawer_background.classList.remove('__active');
        drawer.classList.remove('__active');
    }, false);
});


/*
Load event
*/
window.addEventListener("load", function () {
    const body = document.getElementById('body');

    body.classList.add("__load");
}, false);


// IntersectionObserver
document.addEventListener("DOMContentLoaded", function () {
    const boxes = document.querySelectorAll(".__intersection");
    const boxesArray = Array.prototype.slice.call(boxes, 0);

    const options = {
        root: null,
        rootMargin: "-30% 0px",
        threshold: 0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    boxesArray.forEach(function (box) {
        observer.observe(box);
    });

    /**
     * 交差したときに呼び出す関数
     * @param entries
     */
    function doWhenIntersect(entries) {
        const entriesArray = Array.prototype.slice.call(entries, 0);
        if (entriesArray) {
            entriesArray.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("__inview");
                }
            });
        }
    }
});


// Section
document.addEventListener("DOMContentLoaded", function () {
    const body = document.getElementById('body');
    const section = document.querySelectorAll(".section");
    const sectionArray = Array.prototype.slice.call(section, 0);

    const options = {
        root: null,
        rootMargin: "-50% 0px",
        threshold: 0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    sectionArray.forEach(function (section) {
        observer.observe(section);
    });

    /**
     * 交差したときに呼び出す関数
     * @param entries
     */
    function doWhenIntersect(entries) {
        const entriesArray = Array.prototype.slice.call(entries, 0);
        entriesArray.forEach(function (entry) {
            let data = entry.target.dataset.section;

            if (data) {
                if (entry.isIntersecting) {
                    body.dataset.section = data;
                }
            }
        });
    }
});


// Header hide ctrl
let offset = 0;
let lastPosition = 0;
let ticking = false;
const header_obj = document.getElementsByClassName('global-header');
const header = header_obj[0];
const height = 300;

const onScroll = () => {
    if (lastPosition > height) {
        if (lastPosition > offset) {
            header.classList.add('--animation');
        } else {
            header.classList.remove('--animation');
        }
        offset = lastPosition;
    }
};

document.addEventListener('scroll', () => {
    lastPosition = window.scrollY;
    if (!ticking) {
        window.requestAnimationFrame(() => {
            onScroll();
            ticking = false;
        });
        ticking = true;
    }
});